import React, { memo, Suspense, useContext, useEffect } from "react";
import {
  Redirect,
  Route,
  HashRouter as Router,
  Switch,
} from "react-router-dom";
import CustomRoute from "../components/CustomRoute";

import Root from "./Root";
import { SM } from "./SelfManagement";
import {
  BP,
  BPGuide,
  BPInput,
  BPInputDevice,
  BPInputDeviceGuide,
  BPInputDeviceSettings,
  BPInputList,
  BPMedicine,
  BPMedicineInput,
} from "./SelfManagement/BP";
import {
  BS,
  BSInput,
  BSInputDevice,
  BSInputDeviceGuide,
  BSInputDeviceSettings,
  BSInputList,
  BSMedicine,
  BSMedicineInput,
  BSMedicineSettings,
} from "./SelfManagement/BS";

import { EocsHistory, EocsReceipt, EocsRegist } from "./Eocs";
import {
  PMR,
  PmrHistory,
  PmrInspaction,
  PmrTreatEducation,
} from "./PersonalMedicalRecords";

import { ResrvList, RsrvPayment, Surround, Visit } from "./Reservation";

import { AboutUs, AskUs, Notice, TermsAndPolicy } from "./Company";
import {
  Certification,
  ChangePwd,
  FindEmail,
  FindID,
  Login,
  NewPwd,
  SnsLoginComplete,
} from "./Membership";
import {
  AccuCheck,
  F62E_B,
  InBody,
  Omron,
  SetAccessory,
  SetData,
  SetDelete,
  SetHspt,
  Settings,
  SetUnit,
} from "./Settings";

import SnsLogin from "./Membership/SnsLogin";
import SnsLoginIOS from "./Membership/SnsLoginIOS";
import { MIModify, MIView, MP } from "./MyPage";
import { NoticeBoard } from "./NoticeBoard";
import { Allergy } from "./SelfManagement/Allergy";

import Demo from "../components/Demo";
import IframeBody from "../components/UI/IframeBody";
import CouponList from "./common/Coupon/CouponList";
import PayHistory from "./common/Payment/PayHistory";
import VideoLink from "./common/VideoLink/VideoLink";
import VideoPlayer from "./common/VideoLink/VideoPlayer";
import TermsSelect from "./Company/TermsSelect";
import TermsView from "./Company/TermsView";
import TermsWebView from "./Company/TermsWebView";
import { ExerciseHistory, RecentExercise } from "./Exercise";
import Family from "./Family/Family";
import { AccountMerge } from "./Membership/AccountMerge/AccountMerge";
import { ChangePhoneNumber } from "./Membership/AccountMerge/ChangePhoneNumber";
import { CheckPassword } from "./Membership/AccountMerge/CheckPassword";
import { MergeCertification } from "./Membership/AccountMerge/MergeCertification";
import MergeProgress from "./Membership/AccountMerge/MergeProgress";
import { PhoneCerti } from "./Membership/AccountMerge/PhoneCerti";
import AddAccount from "./Membership/AddAccount";
import CheckCertiNo from "./Membership/CheckCertiNo";
import Help from "./Membership/Help";
import InHospitalCheck from "./Membership/InHospitalCheck";
import InputUserInfo from "./Membership/InputUserInfo";
import LoginAccount from "./Membership/LoginAccount";
import RegistChannel from "./Membership/RegistChannel";
import SearchHospital from "./Membership/SearchHospital";
import ServiceTerms from "./Membership/ServiceTerms";
import SnsVerify from "./Membership/SnsVerify";
import UpdateHsptCnntInfo from "./Membership/UpdateHsptCnntInfo";
import UserAuthCheck from "./Membership/UserAuthCheck";
import UserPhoneCheck from "./Membership/UserPhoneCheck";
import Verification from "./Membership/Verification";
import PasswordChange from "./MyPage/MyInfo/PasswordChange";
import Calculate from "./Nftf/Calculate";
import EmptyPage from "./Nftf/Receipt/EmptyPage";
import NftfGuide from "./Nftf/Receipt/NftfGuide";
import NftfNotice from "./Nftf/Receipt/NftfNotice";
import ReceiptComplete from "./Nftf/Receipt/ReceiptComplete";
import ReceiptIndex from "./Nftf/Receipt/ReceiptIndex";
import ReceiptMain from "./Nftf/Receipt/ReceiptMain";
import ReceiptModify from "./Nftf/Receipt/ReceiptModify";
import MedicalRecord from "./PersonalMedicalRecords/MedicalRecord/MedicalRecord";
import OtherInspaction from "./PersonalMedicalRecords/OtherInspaction/OtherInspaction";
import ProofList from "./PersonalMedicalRecords/Proof/ProofList";
import ProofPay from "./PersonalMedicalRecords/Proof/ProofPay";
import ProofRecipt from "./PersonalMedicalRecords/Proof/ProofRecipt";
import ProofResult from "./PersonalMedicalRecords/Proof/ProofResult";
import TreatmentPay from "./PersonalMedicalRecords/TreatmentData/Payment/TreatmentPay";
import TreatmentData from "./PersonalMedicalRecords/TreatmentData/TreatmentData";
import {
  Proof,
  ProofApply,
  ProofClaim,
  ProofComplete,
  ProofDownload,
  ProofInsurance,
  ProofPayment,
  ProofStorage,
} from "./Proof";
import PushMsg from "./Push/PushMsg";
import { Question } from "./Question";
import HospitalDetail from "./Reservation/HospitalDetail";
import { Schedule } from "./Schedule";
import { BMI, HISTORY, LIST, RCNT } from "./SelfManagement/BMI";
import AddDiet from "./SelfManagement/DIET/AddDiet";
import InspactionResult from "./SelfManagement/InspectionResult/InspectionResult";
import GlueNeoSmart from "./Settings/Accessory/GlueNeoSmart";
import CardManager from "./Settings/CardManager";
import ConnectHospital from "./Settings/ConnectHospital/ConnectHospital";
import Card from "./PayCard/Card";
import { resEvent } from "./Nftf/Interface/NFTF/NativeApi";
import {
  AppContext,
  SET_GPSINFO2,
  SET_PAGE_STATE,
} from "../components/AppProvider";

export default memo(props => {
  const { dispatch, pageState, deviceCfg } = useContext(AppContext);

  useEffect(() => {
    window.NativeInterface = {
      nativeResponse: value => {
        // nativeResponse(value);
        console.log(value);
        resEvent(value, dispatch, deviceCfg);
      },

      getGpsRtn: value => {
        dispatch({ type: SET_GPSINFO2, data: JSON.parse(value) });
      },
    };
  }, []);

  useEffect(() => {
    if (pageState.reload === 1) {
      dispatch({
        type: SET_PAGE_STATE,
        data: { type: "reload", state: 0 },
      });
    }
  }, [pageState.reload]);
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route path="/" exact component={Root} />
          <CustomRoute path="/sm" exact component={SM} />
          <CustomRoute path="/smOpen/:param" exact component={SM} />
          <Route path="/cnntHspt/:regist" exact component={ConnectHospital} />
          <Route
            path="/cnntHspt/:regist/:returnPage"
            exact
            component={ConnectHospital}
          />
          <Route
            path="/updataHsptCnntInfo/:hpKey/:hsptNm/:type/:defaultInfo"
            exact
            component={UpdateHsptCnntInfo}
          />

          <CustomRoute path="/sm/bp/guide/:auto" exact component={BPGuide} />
          <CustomRoute
            path="/sm/bp/:periodType/:startDate/:endDate"
            exact
            component={BP}
          />
          <CustomRoute path="/sm/bp/input" exact component={BPInput} />
          <CustomRoute
            path="/sm/bp/input/:autoInput"
            exact
            component={BPInput}
          />
          <CustomRoute
            path="/sm/bp/input/device"
            exact
            component={BPInputDevice}
          />
          <CustomRoute
            path="/sm/bp/input/device/settings"
            component={BPInputDeviceSettings}
          />
          <CustomRoute
            path="/sm/bp/input/device/guide"
            component={BPInputDeviceGuide}
          />
          <CustomRoute
            path="/sm/bp/list/:periodType/:startDate/:endDate"
            component={BPInputList}
          />
          <CustomRoute
            path="/sm/bp/list/:periodType/:startDate/:endDate/:deviceName"
            component={BPInputList}
          />
          <CustomRoute path="/sm/bp/medicine" exact component={BPMedicine} />
          <CustomRoute
            path="/sm/bp/medicine/input"
            component={BPMedicineInput}
          />
          <CustomRoute
            path="/sm/bp/medicine/input2/:searchDt/:mdcnType"
            component={BPMedicineInput}
          />

          <CustomRoute
            path="/sm/bs/:periodType/:startDate/:endDate"
            exact
            component={BS}
          />
          <CustomRoute path="/sm/bs/input" exact component={BSInput} />
          <CustomRoute
            path="/sm/bs/input/device"
            exact
            component={BSInputDevice}
          />
          <CustomRoute
            path="/sm/bs/input/device/settings"
            component={BSInputDeviceSettings}
          />
          <CustomRoute
            path="/sm/bs/input/device/guide"
            component={BSInputDeviceGuide}
          />
          <CustomRoute
            path="/sm/bs/list/:periodType/:startDate/:endDate"
            component={BSInputList}
          />
          <CustomRoute
            path="/sm/bs/list/:periodType/:startDate/:endDate/:deviceName"
            component={BSInputList}
          />
          <CustomRoute path="/sm/bs/medicine" exact component={BSMedicine} />
          <CustomRoute
            path="/sm/bs/medicine/input"
            component={BSMedicineInput}
          />
          <CustomRoute
            path="/sm/bs/medicine/input2/:searchDt/:mdcnType"
            component={BSMedicineInput}
          />
          <CustomRoute
            path="/sm/bs/medicine/settings"
            component={BSMedicineSettings}
          />

          <CustomRoute path="/sm/bmi/input" component={BMI} />
          <CustomRoute path="/sm/bmi/rcnt" component={RCNT} />
          <CustomRoute
            path="/sm/bmi/history/:periodType/:startDate/:endDate"
            component={HISTORY}
          />
          <CustomRoute
            path="/sm/bmi/list/:periodType/:startDate/:endDate"
            component={LIST}
          />

          <CustomRoute path="/sm/exercise/rcnt" component={RecentExercise} />
          <CustomRoute
            path="/sm/exercise/history/:periodType/:startDate/:endDate"
            component={ExerciseHistory}
          />

          {/* 알레르기 */}
          <CustomRoute path="/sm/allergy" exact component={Allergy} />

          {/* 식단 */}
          <CustomRoute path="/sm/addDiet" exact component={AddDiet} />
          {/* <CustomRoute path="/sm/rcntDiet" exact component={RcntDiet} /> */}

          {/* 검사결과 */}
          <CustomRoute
            path="/sm/isptResult"
            exact
            component={InspactionResult}
          />

          {/* 전자처방전 */}
          <CustomRoute path="/eocs" exact component={EocsReceipt} />
          <CustomRoute
            path="/eocs/receipt/:selectedPxID"
            exact
            component={EocsReceipt}
          />
          <CustomRoute
            path="/eocs/history/:eocsType/:refreshState"
            component={EocsHistory}
          />
          <CustomRoute path="/eocs/history/:eocsType" component={EocsHistory} />
          <CustomRoute path="/eocs/history" component={EocsHistory} />
          <CustomRoute path="/eocs/regist/:info" component={EocsRegist} />

          {/* 개인진료기록 */}
          <CustomRoute path="/pmr" exact component={PMR} />
          <CustomRoute path="/pmr/history" exact component={PmrHistory} />
          <CustomRoute path="/pmr/inspaction" exact component={PmrInspaction} />
          <CustomRoute
            path="/pmr/otherinspaction"
            exact
            component={OtherInspaction}
          />
          <CustomRoute
            path="/pmr/treatEducation"
            exact
            component={PmrTreatEducation}
          />
          <CustomRoute
            path="/pmr/medicalRecord"
            exact
            component={MedicalRecord}
          />
          {/* 제증명 in 개인진료기록 */}
          <CustomRoute path="/pmr/proofRecipt" exact component={ProofRecipt} />
          <CustomRoute
            path="/pmr/proofList/:periodType/:startDate/:endDate"
            // path="/pmr/proofList"
            exact
            component={ProofList}
          />
          <CustomRoute
            path="/pmr/proof/result/:seqNo/:resCd/:resMsg/:userToken"
            exact
            component={ProofResult}
          />
          <CustomRoute
            path="/pmr/proof/pay/:seqNo"
            exact
            component={ProofPay}
          />
          <CustomRoute
            path="/pmr/treatmentData"
            exact
            component={TreatmentData}
          />
          <CustomRoute
            path="/pmr/treatmentData/pay"
            exact
            component={TreatmentPay}
          />

          {/* 병원예약 */}
          <CustomRoute path="/surround" exact component={Surround} />
          <CustomRoute path="/resrvList" exact component={ResrvList} />
          <CustomRoute
            path="/resrvList/:reloadState"
            exact
            component={ResrvList}
          />
          <CustomRoute
            path="/resrvList/:reloadState/:appID"
            exact
            component={ResrvList}
          />
          <CustomRoute
            path="/resrvListAf/:shopOrderNo/:resCd/:resMsg"
            exact
            component={ResrvList}
          />
          <CustomRoute path="/visit" exact component={Visit} />
          <CustomRoute
            // path="/rsrv/payment/:amount/:codeNm/:accountNum/:accountName/:appIdx"
            path="/rsrv/payment/:amount/:appIdx"
            exact
            component={RsrvPayment}
          />

          {/* 마이페이지 */}
          <CustomRoute path="/mp" exact component={MP} />
          <CustomRoute path="/mp/myInfo/view" exact component={MIView} />
          <CustomRoute path="/mp/myInfo/modify" exact component={MIModify} />

          {/* 설정 */}
          <CustomRoute path="/mp/settings/data" exact component={SetData} />
          <CustomRoute
            path="/mp/settings/data/hspt"
            exact
            component={SetHspt}
          />
          <CustomRoute
            path="/mp/settings/data/hspt/:menu"
            exact
            component={SetHspt}
          />
          <CustomRoute path="/mp/settings/delete" exact component={SetDelete} />
          <CustomRoute path="/mp/settings/units" exact component={SetUnit} />
          <CustomRoute
            path="/mp/settings/accessory"
            exact
            component={SetAccessory}
          />
          <CustomRoute
            path="/mp/settings/:fromMain"
            exact
            component={Settings}
          />

          <CustomRoute
            path="/mp/settings/accessory/inbody/:test"
            exact
            component={InBody}
          />
          <CustomRoute
            path="/mp/settings/accessory/omron/:test"
            exact
            component={Omron}
          />
          <CustomRoute
            path="/mp/settings/accessory/accuCheck/:test"
            exact
            component={AccuCheck}
          />
          <CustomRoute
            path="/mp/settings/accessory/glueNeo/:test"
            exact
            component={GlueNeoSmart}
          />
          <CustomRoute
            path="/mp/settings/accessory/f62eb"
            exact
            component={F62E_B}
          />

          {/* 회사 관련 - 공지사항, 약관 및 정책, 회사소개 */}
          <Route path="/mp/notice" exact component={Notice} />
          <Route path="/mp/termsSelect" exact component={TermsSelect} />
          <Route path="/mp/termsView/:target" exact component={TermsView} />
          <Route
            path="/mp/termsWebView/:target"
            exact
            component={TermsWebView}
          />
          <Route path="/mp/terms" exact component={TermsAndPolicy} />
          <CustomRoute path="/mp/askUs" exact component={AskUs} />
          <CustomRoute path="/mp/aboutUs" exact component={AboutUs} />
          <CustomRoute path="/mp/cardManager" exact component={CardManager} />
          <CustomRoute
            path="/mp/cardManager/:dataInfo"
            exact
            component={CardManager}
          />

          {/* 로그인 관련 */}
          <Route
            path="/membership/login/:retUrl/:userId"
            exact
            component={Login}
          />
          <Route path="/membership/login/:retUrl" exact component={Login} />
          <Route path="/membership/login" exact component={Login} />
          <Route path="/membership/findID/:data" exact component={FindID} />
          <Route path="/membership/findEmail" exact component={FindEmail} />
          <Route
            path="/membership/changePwd/:userId/:attctNo"
            exact
            component={ChangePwd}
          />
          <Route
            path="/membership/newPwd/:authKey/:email"
            exact
            component={NewPwd}
          />

          <Route path="/membership/help/:step" exact component={Help} />
          <Route
            path="/membership/help/vrfcn/:userInfo/:color/:submit/:hsptList"
            exact
            component={Verification}
          />
          <Route
            path="/membership/help/vrfcn/:userInfo/:color/:submit"
            exact
            component={Verification}
          />
          <Route
            path="/membership/help/vrfcnLogin/:userInfo/:color/:submit/:attctNo"
            exact
            component={Verification}
          />

          <Route
            path="/membership/snsLogin/:userEmail/:userName/:UID/:signUpChannel"
            exact
            component={SnsLogin}
          />
          <Route
            path="/membership/appleLogin/:UID/:signUpChannel"
            exact
            component={SnsLogin}
          />
          <Route
            path="/membership/snsLoginIOS/:userEmail/:userName/:UID/:signUpChannel"
            exact
            component={SnsLoginIOS}
          />
          <Route
            path="/membership/snsLoginComplete/:info"
            exact
            component={SnsLoginComplete}
          />

          <Route
            path="/membership/userPhoneCheck"
            exact
            component={UserPhoneCheck}
          />

          <Route
            path="/membership/inHsptCheck"
            exact
            component={InHospitalCheck}
          />

          <Route
            path="/membership/inputUserInfo/:signUpChannel"
            exact
            component={InputUserInfo}
          />

          <Route
            path="/membership/inputUserInfo/:signUpChannel/:userId"
            exact
            component={InputUserInfo}
          />

          <Route
            path="/membership/checkCertiNo"
            exact
            component={CheckCertiNo}
          />

          <Route
            path="/membership/checkCertiNo/:certiNo"
            exact
            component={CheckCertiNo}
          />

          <Route
            path="/membership/serviceTerms/:signUpChannel"
            exact
            component={ServiceTerms}
          />

          <Route
            path="/membership/registChannel/:info"
            exact
            component={RegistChannel}
          />

          <Route
            path="/membership/addAccount/:mode/:info"
            exact
            component={AddAccount}
          />

          <Route
            path="/membership/loginAccount/"
            exact
            component={LoginAccount}
          />

          <Route
            path="/membership/loginAccount/:userId"
            exact
            component={LoginAccount}
          />

          <Route
            path="/membership/searchHospital"
            exact
            component={SearchHospital}
          />

          {/* 본인인증 */}
          <Route
            path="/membership/userAuthCheck"
            exact
            component={UserAuthCheck}
          />

          <Route
            path="/membership/certification"
            exact
            component={Certification}
          />
          <Route path="/membership/acntMerge" exact component={AccountMerge} />
          <Route
            path="/membership/phoneCerti/:returnTarget"
            exact
            component={PhoneCerti}
          />
          <Route
            path="/membership/mergeReady/:trgtUserToken"
            exact
            component={MergeProgress}
          />

          <Route path="/membership/chkPw/" exact component={CheckPassword} />
          <Route
            path="/membership/newNum/"
            exact
            component={ChangePhoneNumber}
          />
          <Route
            path="/membership/certi/:type"
            exact
            component={MergeCertification}
          />
          <Route
            path="/membership/certi/:type/:trgtUserToken"
            exact
            component={MergeCertification}
          />
          <Route
            path="/membership/certi/:type/:trgtUserToken/:phoneNumber"
            exact
            component={MergeCertification}
          />
          <Route
            path="/membership/snsVerify/:UID"
            exact
            component={SnsVerify}
          />

          <Route path="/membership/pwCng" exact component={PasswordChange} />

          {/* 알림판 */}
          <CustomRoute path="/noticeBoard" exact component={NoticeBoard} />

          {/* 문의 */}
          <CustomRoute path="/question" exact component={Question} />

          {/* 제증명 */}
          <CustomRoute path="/proof" exact component={Proof} />
          <CustomRoute path="/proof/apply" exact component={ProofApply} />
          <CustomRoute
            path="/proof/storage/:periodType/:startDate/:endDate"
            exact
            component={ProofStorage}
          />
          <CustomRoute
            path="/proof/storage/:periodType/:startDate/:endDate/:reload"
            exact
            component={ProofStorage}
          />
          <CustomRoute
            path="/proof/complete/:seqNo/:resCd/:resMsg/:userToken"
            exact
            component={ProofComplete}
          />

          <CustomRoute
            path="/proof/insurance"
            exact
            component={ProofInsurance}
          />
          <CustomRoute path="/proof/claim" exact component={ProofClaim} />
          <CustomRoute path="/proof/download" exact component={ProofDownload} />
          <CustomRoute
            path="/proof/payment/:seqNo"
            exact
            component={ProofPayment}
          />
          <CustomRoute
            path="/cmmn/iframeBody/:moveUrl"
            exact
            component={IframeBody}
          />

          <CustomRoute
            path="/cmmn/iframeBody/:moveUrl/:backUrl"
            exact
            component={IframeBody}
          />

          {/* 스케쥴 */}
          <CustomRoute path="/schedule" exact component={Schedule} />
          <CustomRoute
            path="/schedule/:targetDate"
            exact
            component={Schedule}
          />

          {/* 영상 */}
          <CustomRoute
            path="/videoLink/:linkUrl/:thumbNail/:studyDesc/:returnUrl"
            exact
            component={VideoLink}
          />
          <CustomRoute path="/videoPlayer" exact component={VideoPlayer} />

          {/* 푸쉬 */}
          <Route path="/push/:msgId" exact component={PushMsg} />
          <Route path="/calculate" exact component={Calculate} />

          <CustomRoute
            path="/nftf/index/:hsptData"
            exact
            component={ReceiptIndex}
          />
          <CustomRoute
            path="/nftf/index/:hsptData/:pageIdx"
            exact
            component={ReceiptIndex}
          />
          <CustomRoute
            path="/nftf/index/:hsptData/:pageIdx/:seqNo/:status"
            exact
            component={ReceiptIndex}
          />

          <CustomRoute path="/nftf/main" exact component={ReceiptMain} />
          <CustomRoute
            path="/nftf/complete"
            exact
            component={ReceiptComplete}
          />
          <CustomRoute
            path="/nftf/payHistory/:data"
            exact
            component={PayHistory}
          />
          <CustomRoute
            path="/nftf/receiptMod/:seqNo"
            exact
            component={ReceiptModify}
          />
          <Route path="/nftf/main/:seqNo" exact component={Root} />
          <Route path="/nftf/main/:seqNo/:reload" exact component={Root} />

          <CustomRoute path="/common/loading" exact component={EmptyPage} />
          <CustomRoute
            path="/common/loading/:param"
            exact
            component={EmptyPage}
          />

          <Route path="/demo" exact component={Demo} />
          <Route path="/nftf/notice" exact component={NftfNotice} />
          <Route path="/nftf/guide" exact component={NftfGuide} />
          <Route path="/hspt/detail" exact component={HospitalDetail} />

          <Route path="/mp/couponList" exact component={CouponList} />

          {/* 가족관리 */}
          <Route path="/family" exact component={Family} />
          {/* 가족관리 */}

          {/* 결제수단 관리 */}
          <Route path="/card" exact component={Card} />
          {/* 결제수단 관리 */}

          <Redirect path="*" to="/" />
        </Switch>
      </Suspense>
    </Router>
  );
});
